<div *ngIf="userDetails" class="dashboard">
    <div class="dashboard__profile card profile-card">
        <div class="card-body profile-card__body">

            <div class="profile-card__name">Total Loyalty Points: {{''}}</div>
            <div class="profile-card__name">Some Other Field: ????{{''}}</div>

        </div>
    </div>

    <div class="dashboard__orders card">
        <div class="card-header">
            <h5>Loyalty points log:</h5>
        </div>
        <div class="card-divider"></div>
        <div class="card-table">
            <div class="table-responsive-sm">
                <table>
                    <thead>
                        <tr>
                            <th>Order</th>
                            <th>Date</th>
                            <th>Total</th>
                            <th>Points</th>
                            <th>Points Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let order of orders">
                            <td><a [routerLink]="['/account/orders/' , order.orderId]">#{{ order.orderId }}</a></td>
                            <td>{{ order.orderDate |date }}</td>
                            <td>{{ order.total }}</td>
                            <td>{{ order.points }} </td>
                            <td>{{ order.points }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
